import { useCallback, useState } from 'react';
import { SimpleFileFragmentType } from '@common/graphql';

export const useDisputeDeletedFiles = (files: SimpleFileFragmentType[]) => {
  const [removedFiles, setRemovedFiles] = useState<SimpleFileFragmentType[]>(
    []
  );
  const handleDeletion = useCallback(
    (file: SimpleFileFragmentType) =>
      setRemovedFiles((files) => [...files, file]),
    []
  );

  const maxFilesSlots = 3 - (files.length - removedFiles.length);

  return [removedFiles, handleDeletion, maxFilesSlots] as const;
};
